import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

import { useParams } from "react-router-dom";

import UserApi from "../../api/UserApi";
import ProjectApi from "../../api/projectApi";

function DeveloperProjectDetails() {
  const { id } = useParams();

  /* =========================================================
     PROJECT
  ========================================================= */

  const [data, setData] = useState(null);

  const [loading, setLoading] = useState(true);

  /* =========================================================
     PROJECT STATUS
  ========================================================= */

  const [projectStatus, setProjectStatus] = useState("");

  /* =========================================================
     TESTERS
  ========================================================= */

  const [testers, setTesters] = useState([]);

  const [testerId, setTesterId] = useState("");

  /* =========================================================
     TESTING CREDENTIALS
  ========================================================= */

  const [testingUrl, setTestingUrl] = useState("");

  const [adminUrl, setAdminUrl] = useState("");

  const [testingUsername, setTestingUsername] = useState("");

  const [testingPassword, setTestingPassword] = useState("");

  const [testingNotes, setTestingNotes] = useState("");

  /* =========================================================
     FETCH PROJECT DETAILS
  ========================================================= */

  const fetchDetails = async () => {
    try {
      setLoading(true);

      const res = await ProjectApi.details(id);

      console.log("PROJECT DETAILS RESPONSE:", res);

      if (res?.code !== 200) {
        setData(null);
        return;
      }

      /*
       * Backend response ko flexible rakha gaya hai.
       *
       * Possible responses:
       *
       * res.data
       * res.data.project
       * res.data.data
       */

      const project =
        res?.data?.project || res?.data?.data || res?.data || null;

      console.log("NORMALIZED PROJECT:", project);

      if (!project) {
        setData(null);
        return;
      }

      setData(project);

      /* =====================================================
         PROJECT STATUS
      ===================================================== */

      setProjectStatus(project?.projectStatus || "pending");

      /* =====================================================
         ASSIGNED TESTER
      ===================================================== */

      setTesterId(
        project?.assignedTester?._id || project?.assignedTester || "",
      );

      /* =====================================================
         TESTING URL
      ===================================================== */

      setTestingUrl(project?.testingUrl || "");

      /* =====================================================
         ADMIN URL
      ===================================================== */

      setAdminUrl(project?.adminUrl || "");

      /* =====================================================
         TESTING USERNAME
      ===================================================== */

      setTestingUsername(project?.testingUsername || "");

      /* =====================================================
         TESTING PASSWORD
      ===================================================== */

      setTestingPassword(project?.testingPassword || "");

      /* =====================================================
         TESTING NOTES
      ===================================================== */

      setTestingNotes(project?.testingNotes || "");
    } catch (error) {
      console.error("FETCH PROJECT DETAILS ERROR:", error);

      setData(null);
    } finally {
      setLoading(false);
    }
  };

  /* =========================================================
     LOAD TESTERS
  ========================================================= */

  const loadTesters = async () => {
    try {
      console.log("LOADING TESTERS...");

      const res = await UserApi.testerUsers();

      console.log("TESTERS API RESPONSE:", res);

      if (res?.code !== 200) {
        setTesters([]);
        return;
      }

      let testerList = [];

      /*
       * Handle different response structures.
       */

      if (Array.isArray(res?.data)) {
        testerList = res.data;
      } else if (Array.isArray(res?.data?.users)) {
        testerList = res.data.users;
      } else if (Array.isArray(res?.users)) {
        testerList = res.users;
      }

      console.log("FINAL TESTER LIST:", testerList);

      setTesters(testerList);
    } catch (error) {
      console.error("FAILED TO LOAD TESTERS:", error);

      setTesters([]);
    }
  };

  /* =========================================================
     UPDATE PROJECT STATUS
  ========================================================= */
const updateStatus = async () => {
  try {
    if (!projectStatus) {
      toast.warning("Please select project status");
      return;
    }

    const res = await ProjectApi.updateStatus(id, {
      projectStatus,
    });

    console.log("STATUS UPDATE RESPONSE:", res);

    if (res?.code === 200) {
      toast.success("Status updated successfully");

      await fetchDetails();
    } else {
      toast.error(
        res?.message || "Failed to update project status"
      );
    }
  } catch (error) {
    console.error("UPDATE STATUS ERROR:", error);

    toast.error(
      error?.response?.data?.message ||
        error?.message ||
        "Failed to update project status"
    );
  }
};

  /* =========================================================
     SEND PROJECT TO TESTING
  ========================================================= */

const handoverToTesting = async () => {
  try {
    /* =====================================================
       TESTER VALIDATION
    ===================================================== */

    if (!testerId) {
      toast.warning("Please select a tester");
      return;
    }

    /* =====================================================
       WEBSITE URL VALIDATION
    ===================================================== */

    if (!testingUrl.trim()) {
      toast.warning("Please enter Website URL");
      return;
    }

    const payload = {
      assignedTester: testerId,

      testingUrl: testingUrl.trim(),

      adminUrl: adminUrl.trim(),

      testingUsername: testingUsername.trim(),

      testingPassword: testingPassword,

      testingNotes: testingNotes.trim(),
    };

    console.log("HANDOVER PAYLOAD:", payload);

    const res = await ProjectApi.handoverToTesting(
      id,
      payload
    );

    console.log("HANDOVER RESPONSE:", res);

    if (res?.code === 200) {
      toast.success(
        "Project successfully sent for testing"
      );

      await fetchDetails();
    } else {
      toast.error(
        res?.message ||
          "Failed to send project for testing"
      );
    }
  } catch (error) {
    console.error("HANDOVER ERROR:", error);

    toast.error(
      error?.response?.data?.message ||
        error?.message ||
        "Failed to send project for testing"
    );
  }
};
  /* =========================================================
     LOAD DATA
  ========================================================= */

  useEffect(() => {
    if (!id) {
      return;
    }

    fetchDetails();
    loadTesters();
  }, [id]);

  /* =========================================================
     LOADING
  ========================================================= */

  if (loading) {
    return (
      <div className="content">
        <div className="text-center py-5">Loading Project...</div>
      </div>
    );
  }

  /* =========================================================
     PROJECT NOT FOUND
  ========================================================= */

  if (!data) {
    return (
      <div className="content">
        <div className="card border-0 shadow-sm">
          <div className="card-body text-center py-5">
            <h5>Project Not Found</h5>

            <p className="text-muted mb-0">Unable to load project details.</p>
          </div>
        </div>
      </div>
    );
  }

  /* =========================================================
     PROJECT OBJECT
  ========================================================= */

  const project = data || {};

  /* =========================================================
     LEAD
  ========================================================= */

  const lead = project?.leadId || null;

  /* =========================================================
     ASSIGNED DEVELOPER
  ========================================================= */

  const assignedDeveloper = project?.assignedDeveloper || null;

  /* =========================================================
     ASSIGNED TESTER
  ========================================================= */

  const assignedTester = project?.assignedTester || null;

  /* =========================================================
     DOCUMENTS
  ========================================================= */

  const documents = Array.isArray(project?.documents) ? project.documents : [];

  /* =========================================================
     RETURN
  ========================================================= */

  return (
    <div className="content">
      {/* =====================================================
          HEADER
      ===================================================== */}

      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h2 className="fw-bold mb-1">{project?.projectName || "Project"}</h2>

          <p className="text-muted mb-0">Complete Client & Project Overview</p>
        </div>

        <div className="d-flex gap-2">
          <span className="badge bg-danger fs-12 px-3 py-2">
            {project?.priority || "N/A"}
          </span>

          <span className="badge bg-warning text-dark fs-12 px-3 py-2">
            {project?.projectStatus || "N/A"}
          </span>
        </div>
      </div>

      {/* =====================================================
          MAIN ROW
      ===================================================== */}

      <div className="row">
        {/* ===================================================
            LEFT SIDE
        =================================================== */}

        <div className="col-lg-8">
          {/* =================================================
              CLIENT INFORMATION
          ================================================= */}

          <div className="card border-0 shadow-sm mb-4">
            <div className="card-header bg-white">
              <h5 className="mb-0">Client Information</h5>
            </div>

            <div className="card-body">
              <div className="row">
                {/* CLIENT NAME */}

                <div className="col-md-6 mb-4">
                  <h6>Client Name</h6>

                  <p className="mb-0">{lead?.name || "N/A"}</p>
                </div>

                {/* EMAIL */}

                <div className="col-md-6 mb-4">
                  <h6>Email</h6>

                  <p className="mb-0">{lead?.email || "N/A"}</p>
                </div>

                {/* PHONE */}

                <div className="col-md-6 mb-4">
                  <h6>Phone</h6>

                  <p className="mb-0">{lead?.phone || "N/A"}</p>
                </div>

                {/* BUSINESS */}

                <div className="col-md-6 mb-4">
                  <h6>Business</h6>

                  <p className="mb-0">
                    {lead?.company_name || lead?.companyName || "N/A"}
                  </p>
                </div>

                {/* LEAD SOURCE */}

                <div className="col-md-6 mb-4">
                  <h6>Lead Source</h6>

                  <p className="mb-0">
                    {lead?.sourceId?.source || lead?.source || "N/A"}
                  </p>
                </div>

                {/* SALES PERSON */}

                <div className="col-md-6 mb-4">
                  <h6>Assigned Sales Person</h6>

                  <p className="mb-0">{lead?.assignedTo?.name || "N/A"}</p>
                </div>
              </div>
            </div>
          </div>

          {/* =================================================
              PROJECT INFORMATION
          ================================================= */}

          <div className="card border-0 shadow-sm mb-4">
            <div className="card-header bg-white">
              <h5 className="mb-0">Project Information</h5>
            </div>

            <div className="card-body">
              <div className="row">
                {/* PROJECT NAME */}

                <div className="col-md-6 mb-4">
                  <h6>Project Name</h6>

                  <p className="mb-0">{project?.projectName || "N/A"}</p>
                </div>

                {/* PRIORITY */}

                <div className="col-md-6 mb-4">
                  <h6>Priority</h6>

                  <p className="mb-0 text-capitalize">
                    {project?.priority || "N/A"}
                  </p>
                </div>

                {/* ASSIGNED DEVELOPER */}

                <div className="col-md-6 mb-4">
                  <h6>Assigned Developer</h6>

                  <p className="mb-0">
                    {assignedDeveloper?.name ||
                      assignedDeveloper?.username ||
                      assignedDeveloper?.email ||
                      "N/A"}
                  </p>
                </div>

                {/* DEADLINE */}

                <div className="col-md-6 mb-4">
                  <h6>Deadline</h6>

                  <p className="mb-0">
                    {project?.deadline
                      ? new Date(project.deadline).toLocaleDateString()
                      : "N/A"}
                  </p>
                </div>

                {/* PROJECT STATUS */}

                <div className="col-md-6 mb-4">
                  <h6>Project Status</h6>

                  <p className="mb-0 text-capitalize">
                    {project?.projectStatus?.replace("_", " ") || "N/A"}
                  </p>
                </div>

                {/* TESTING STATUS */}

                <div className="col-md-6 mb-4">
                  <h6>Testing Status</h6>

                  <p className="mb-0 text-capitalize">
                    {project?.testingStatus?.replace("_", " ") || "N/A"}
                  </p>
                </div>

                {/* INTERNAL NOTES */}

                <div className="col-md-12">
                  <h6>Internal Notes</h6>

                  <div className="border rounded p-3 bg-light">
                    {project?.notes || "N/A"}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* =================================================
              TESTING CREDENTIALS
          ================================================= */}

          <div className="card border-0 shadow-sm mb-4">
            <div className="card-header bg-white">
              <h5 className="mb-0">Testing Credentials</h5>
            </div>

            <div className="card-body">
              {/* WEBSITE URL */}

              <div className="mb-3">
                <label className="form-label">Website URL</label>

                <input
                  type="url"
                  className="form-control"
                  placeholder="Enter website URL"
                  value={testingUrl}
                  onChange={(e) => setTestingUrl(e.target.value)}
                  disabled={
                    project?.projectStatus === "testing" ||
                    project?.projectStatus === "completed"
                  }
                />
              </div>

              {/* ADMIN URL */}

              <div className="mb-3">
                <label className="form-label">Admin URL</label>

                <input
                  type="url"
                  className="form-control"
                  placeholder="Enter admin URL"
                  value={adminUrl}
                  onChange={(e) => setAdminUrl(e.target.value)}
                  disabled={
                    project?.projectStatus === "testing" ||
                    project?.projectStatus === "completed"
                  }
                />
              </div>

              {/* USERNAME */}

              <div className="mb-3">
                <label className="form-label">Username</label>

                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter username"
                  value={testingUsername}
                  onChange={(e) => setTestingUsername(e.target.value)}
                  disabled={
                    project?.projectStatus === "testing" ||
                    project?.projectStatus === "completed"
                  }
                />
              </div>

              {/* PASSWORD */}

              <div className="mb-3">
                <label className="form-label">Password</label>

                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter password"
                  value={testingPassword}
                  onChange={(e) => setTestingPassword(e.target.value)}
                  disabled={
                    project?.projectStatus === "testing" ||
                    project?.projectStatus === "completed"
                  }
                />
              </div>

              {/* TESTING NOTES */}

              <div className="mb-0">
                <label className="form-label">Testing Notes</label>

                <textarea
                  rows="4"
                  className="form-control"
                  placeholder="Enter testing instructions"
                  value={testingNotes}
                  onChange={(e) => setTestingNotes(e.target.value)}
                  disabled={
                    project?.projectStatus === "testing" ||
                    project?.projectStatus === "completed"
                  }
                />
              </div>
            </div>
          </div>
        </div>

        {/* ===================================================
            RIGHT SIDE
        =================================================== */}

        <div className="col-lg-4">
          {/* =================================================
              PROJECT STATUS
          ================================================= */}

          <div className="card border-0 shadow-sm mb-4">
            <div className="card-header bg-white">
              <h5 className="mb-0">Project Status</h5>
            </div>

            <div className="card-body">
              <select
                className="form-select mb-3"
                value={projectStatus}
                onChange={(e) => setProjectStatus(e.target.value)}
                disabled={
                  project?.projectStatus === "testing" ||
                  project?.projectStatus === "completed"
                }
              >
                <option value="pending">Pending</option>

                <option value="in_progress">In Progress</option>
              </select>

              {project?.projectStatus !== "testing" &&
                project?.projectStatus !== "completed" && (
                  <button
                    type="button"
                    className="btn btn-primary w-100"
                    onClick={updateStatus}
                  >
                    Update Status
                  </button>
                )}
            </div>
          </div>

          {/* =================================================
              TESTING HANDOVER
          ================================================= */}

          <div className="card border-0 shadow-sm mb-4">
            <div className="card-header bg-white">
              <h5 className="mb-0">Testing Handover</h5>
            </div>

            <div className="card-body">
              {/* ALREADY IN TESTING */}

              {project?.projectStatus === "testing" ? (
                <div className="alert alert-info mb-0">
                  <strong>Project is already in testing.</strong>

                  {assignedTester?.name && (
                    <div className="mt-2">
                      Assigned Tester: <strong>{assignedTester.name}</strong>
                    </div>
                  )}
                </div>
              ) : project?.projectStatus === "completed" ? (
                /* COMPLETED */

                <div className="alert alert-success mb-0">
                  Project has been completed.
                </div>
              ) : (
                <>
                  {/* SELECT TESTER */}

                  <div className="mb-3">
                    <label className="form-label">Select Tester</label>

                    <select
                      className="form-select"
                      value={testerId}
                      onChange={(e) => setTesterId(e.target.value)}
                    >
                      <option value="">Select Tester</option>

                      {testers.map((tester) => (
                        <option key={tester?._id} value={tester?._id}>
                          {tester?.name ||
                            tester?.username ||
                            tester?.email ||
                            "Unnamed Tester"}
                        </option>
                      ))}
                    </select>

                    {testers.length === 0 && (
                      <small className="text-danger d-block mt-2">
                        No testers found.
                      </small>
                    )}
                  </div>

                  {/* SEND TO TESTING */}

                  <button
                    type="button"
                    className="btn btn-success w-100"
                    onClick={handoverToTesting}
                  >
                    Send To Testing
                  </button>
                </>
              )}
            </div>
          </div>

          {/* =================================================
              ASSIGNED TESTER INFORMATION
          ================================================= */}

          {assignedTester && (
            <div className="card border-0 shadow-sm mb-4">
              <div className="card-header bg-white">
                <h5 className="mb-0">Assigned Tester</h5>
              </div>

              <div className="card-body">
                <h6 className="mb-1">
                  {assignedTester?.name || assignedTester?.username || "Tester"}
                </h6>

                {assignedTester?.email && (
                  <p className="text-muted mb-0">{assignedTester.email}</p>
                )}
              </div>
            </div>
          )}

          {/* =================================================
              DOCUMENTS
          ================================================= */}

          <div className="card border-0 shadow-sm mb-4">
            <div className="card-header bg-white">
              <h5 className="mb-0">Documents</h5>
            </div>

            <div className="card-body">
              {documents.length === 0 ? (
                <p className="text-muted mb-0">No Documents</p>
              ) : (
                documents.map((doc) => (
                  <div key={doc?._id} className="border rounded p-3 mb-3">
                    {/* DOCUMENT NUMBER */}

                    <div className="fw-semibold mb-3">
                      📄 {doc?.documentNumber || doc?.name || "Document"}
                    </div>

                    <div className="d-flex gap-2">
                      {/* VIEW */}

                      <button
                        type="button"
                        className="btn btn-primary btn-sm w-50"
                        onClick={() =>
                          window.open(
                            `http://localhost:5000/api/v1/documents/download/${doc?._id}`,
                            "_blank",
                          )
                        }
                      >
                        View
                      </button>

                      {/* DOWNLOAD */}

                      <a
                        href={`http://localhost:5000/api/v1/documents/download/${doc?._id}`}
                        download
                        className="btn btn-outline-dark btn-sm w-50"
                      >
                        Download
                      </a>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DeveloperProjectDetails;
